import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBranch } from 'Services/Features/Branch/Utils/branchUtils';
import { setSetupOrder } from 'Services/Features/Order/orderSlice';

const SelectBranchOrder = () => {
    const dispatch = useDispatch();
    const dataSetupOrder = useSelector(state => state.order.setupOrder);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleChangeBranch = (selectedOption) => {
        setSelectedValue(selectedOption === null ? '' : selectedOption);
        dispatch(setSetupOrder({ 
            branch_id: selectedOption === null ? '' : selectedOption.value,
            branch_name: selectedOption === null ? '' : selectedOption.label
        }));
    };
    
    useEffect(() => {
        const selectedBranch = dataSetupOrder.branch_id ? {
            value: dataSetupOrder.branch_id,
            label: dataSetupOrder.branch_name
        } : null;
        setSelectedValue(selectedBranch);
    }, [dataSetupOrder.branch_id, dataSetupOrder.branch_name]);

    const promiseOptionBranch = (inputValue, callback) => {
        dispatch(getBranch({
            'filter[name]': inputValue,
            'sort': 'name',
            'page': 1,
        }))
            .then((response) => {
                const options = response.payload.data.map(item => ({
                    value: item.id,
                    label: item.name,
                }));
                callback(options);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
                callback([]);
            });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptionBranch}
            handleChange={(selectedOption) => handleChangeBranch(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Cabang"
            isMulti={false}
        />
    )
}

export default SelectBranchOrder;
